/**
 * Perfil pré-conta (anónimo) — antes do register-pending.
 */

export const SIGNUP_PROFILE_KEY = 'iron_signup_profile_v1';
export const SIGNUP_PROFILE_VERSION = 1;

export function createSignupSessionId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `signup-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function readSignupProfileCache() {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(SIGNUP_PROFILE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if ((parsed?.draftVersion || 0) < SIGNUP_PROFILE_VERSION) {
      localStorage.removeItem(SIGNUP_PROFILE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function writeSignupProfileCache(profile, sessionId) {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(
      SIGNUP_PROFILE_KEY,
      JSON.stringify({
        draftVersion: SIGNUP_PROFILE_VERSION,
        sessionId: sessionId || createSignupSessionId(),
        profile,
        savedAt: new Date().toISOString()
      })
    );
  } catch {
    /* quota */
  }
}

export function clearSignupProfileCache() {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(SIGNUP_PROFILE_KEY);
  } catch {
    /* ok */
  }
}

export function hasValidSignupProfileCache() {
  const d = readSignupProfileCache();
  return !!(d?.profile && typeof d.profile === 'object');
}

export const SIGNUP_COMPOSITION_BRIDGE_KEY = 'iron_signup_composition_bridge';

export function writeSignupCompositionBridge(composition) {
  if (typeof localStorage === 'undefined') return;
  if (!Array.isArray(composition) || composition.length === 0) return;
  try {
    localStorage.setItem(SIGNUP_COMPOSITION_BRIDGE_KEY, JSON.stringify(composition));
  } catch {
    /* quota */
  }
}

export function readAndClearSignupCompositionBridge() {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(SIGNUP_COMPOSITION_BRIDGE_KEY);
    localStorage.removeItem(SIGNUP_COMPOSITION_BRIDGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    localStorage.removeItem(SIGNUP_COMPOSITION_BRIDGE_KEY);
    return null;
  }
}
